import React from "react";
import type { BuilderStepProps } from "campaign-builder/config";
import { CampaignDetailsCard } from "./CampaignDetailsCard";
import { TargetingCard } from "./TargetingCard";
import { H2hMap } from "./H2hMap";

// H2H targeting. Campaign Details (name only — H2H scheduling is per-area, F6)
// + the shared city/map/areas card, with the H2H distribution-point map (F4)
// rendered inside the map region. The TargetingProvider lives above the shell
// (CampaignBuilder) so state survives step switches (PAD-31560).
export const H2hTargetingStep: React.ComponentType<BuilderStepProps> = () => (
  <div className="flex flex-col gap-4">
    <CampaignDetailsCard />
    <TargetingCard>
      <H2hMap />
    </TargetingCard>
  </div>
);
